<script setup lang="ts"></script>

<template>
  <div class="mt-6" aria-live="polite">
    <div class="flex items-center p-4 border border-solid rounded-md border-nuts-neutral-400">
      <img
        alt="boxes"
        aria-hidden="true"
        class="object-contain w-20 h-20 shrink-0"
        src="@/assets/auto-delivery/stacked-boxes.jpg"
      />
      <div class="flex flex-col ml-4">
        <img
          class="h-4 sm:h-[18px] grow-0 w-min mb-1"
          alt="Auto Delivery"
          src="@/assets/auto-delivery/logo-gray.svg"
        />
        <span class="text-sm sm:text-base text-neutral-500">
          Until canceled, your product will be added to your recurring Auto-Delivery order.
        </span>
      </div>
    </div>
    <div class="flex items-center p-4 mt-4 border border-solid rounded-md border-nuts-neutral-400">
      <img
        alt="boxes with products"
        aria-hidden="true"
        class="object-contain w-20 h-20 shrink-0"
        src="@/assets/auto-delivery/open-box.jpg"
      />
      <div class="flex flex-col ml-4">
        <strong class="text-base sm:text-lg">
          One-Time
          <img
            class="h-4 sm:h-[18px] grow-0 w-min sm:mb-0.5"
            alt="Auto Delivery"
            src="@/assets/auto-delivery/logo-gray.svg"
          />
        </strong>
        <span class="text-sm sm:text-base text-neutral-500">
          You will receive your product with your upcoming Auto-Delivery; it will not be included in
          future Auto-Delivery orders.
        </span>
      </div>
    </div>
  </div>
</template>
